export default (props, vars) =>
  props?.['activeIndex'] === vars?.['defaultButton2']?.['index'] && 'active';
